<template>
  <el-dialog :visible.sync="visible" width="min(860px, calc(100vw - 24px))" :close-on-click-modal="false" append-to-body @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="readonly && form.id" class="doc-dialog-actions">
          <el-button-group>
            <workflow-doc-buttons biz-type="receiptRed" :biz-id="form.id" perm="finance:receiptRed" :approve-status="String(form.approveStatus || '0')" @approve="approve(form, true)" @unapprove="approve(form, false)" />
            <el-button v-if="isAuth('finance:receiptRed:update') || isAuth('finance:receiptRed:save')" type="primary" size="small" :disabled="!canEditDoc" @click="editFromView">修改</el-button>
            <el-button v-if="isAuth('finance:receiptRed:delete') || isAuth('finance:receiptRed:save')" type="danger" size="small" :disabled="!canEditDoc" @click="deleteFromView">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : formRules" :disabled="readonly" label-width="110px">
      <el-form-item label="红冲单号" prop="code"><el-input v-model="form.code" :disabled="codeReadonly || !!form.id" :placeholder="codeReadonly ? '保存时自动生成' : ''" /></el-form-item>
      <el-form-item label="红冲日期" prop="bizDate">
        <el-date-picker v-model="form.bizDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
      </el-form-item>
      <el-form-item label="客户" prop="customerId">
        <el-input :value="form.partnerName" readonly placeholder="请选择客户">
          <el-button v-if="!readonly" slot="append" @click="picker = true">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="原收款单" prop="sourceId">
        <el-select v-model="form.sourceId" filterable style="width:100%" @change="loadBlueLines">
          <el-option v-for="item in approvedSources" :key="item.id" :label="(item.code || '') + ' ' + (item.partnerName || '')" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="红冲金额"><span>{{ money(writeOffTotal) }}</span></el-form-item>
      <el-table class="red-lines-table" :data="form.lines" border size="small" :header-cell-style="headStyle">
        <el-table-column type="index" label="序号" width="55" align="center" />
        <el-table-column label="类型" width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.salesInvoiceId" size="mini">销项发票</el-tag>
            <el-tag v-else type="warning" size="mini">应收</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="单号" min-width="140">
          <template slot-scope="scope">{{ scope.row.salesInvoiceCode || scope.row.receivableCode }}</template>
        </el-table-column>
        <el-table-column :label="readonly ? '剩余可红冲' : '可红冲'" width="110" align="right">
          <template slot-scope="scope">{{ money(displayRemain(scope.row)) }}</template>
        </el-table-column>
        <el-table-column label="红冲核销" width="150">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.writeOffMoney" :min="0" :max="readonly ? Math.max(Number(scope.row.writeOffMoney || 0), Number(scope.row.remainWriteOff || 0)) : Number(scope.row.remainWriteOff || 0)" :precision="2" :disabled="readonly" size="small" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column v-if="!readonly" label="操作" width="60" align="center">
          <template slot-scope="scope"><el-button type="text" size="small" @click="form.lines.splice(scope.$index, 1)">删</el-button></template>
        </el-table-column>
      </el-table>
      <div class="red-lines-mobile">
        <div v-for="(line, index) in form.lines" :key="line.receiptLineId || line.paymentLineId || index" class="red-line-card">
          <div class="red-line-head">
            <el-tag :type="line.salesInvoiceId ? '' : 'warning'" size="mini">{{ line.salesInvoiceId ? '销项发票' : '应收' }}</el-tag>
            <strong>{{ line.salesInvoiceCode || line.receivableCode }}</strong>
            <el-button v-if="!readonly" type="text" size="small" @click="form.lines.splice(index, 1)">移除</el-button>
          </div>
          <div class="red-line-amount">
            <span>{{ readonly ? '剩余可红冲' : '可红冲' }} {{ money(displayRemain(line)) }}</span>
            <el-input-number v-model="line.writeOffMoney" :min="0"
              :max="readonly ? Math.max(Number(line.writeOffMoney || 0), Number(line.remainWriteOff || 0)) : Number(line.remainWriteOff || 0)"
              :precision="2" :disabled="readonly" size="small" />
          </div>
        </div>
      </div>
      <el-form-item label="备注" style="margin-top:12px"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
    </span>
    <CustomerSelector :visible.sync="picker" @select="onPick" />
  </el-dialog>
</template>

<script>
import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'
import CustomerSelector from '../../components/CustomerSelector.vue'
import request from '../../api/request'
import auth from './financeAuth'

export default {
  name: 'ReceiptRedAddOrUpdate',
  mixins: [auth],
  components: { WorkflowDocButtons, CustomerSelector },
  data() {
    return {
      visible: false,
      readonly: false,
      codeReadonly: false,
      picker: false,
      sources: [],
      form: this.blank(),
      rules: {
        code: [{ required: true, message: '红冲单号不能为空', trigger: 'blur' }],
        bizDate: [{ required: true, message: '红冲日期不能为空', trigger: 'change' }],
        customerId: [{ required: true, message: '客户不能为空', trigger: 'change' }],
        sourceId: [{ required: true, message: '原收款单不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    formRules() {
      return this.codeReadonly ? { ...this.rules, code: [] } : this.rules
    },
    dialogTitle() {
      if (this.readonly) return '查看收款红冲'
      return this.form.id ? '修改收款红冲' : '新增收款红冲'
    },
    approvedSources() {
      return this.sources.filter(item => String(item.approveStatus) === '2')
    },
    writeOffTotal() {
      return (this.form.lines || []).reduce((sum, line) => sum + Number(line.writeOffMoney || 0), 0)
    }
  },
  methods: {
    displayRemain(line) {
      const available = Number(line.remainWriteOff || 0)
      return this.readonly ? Math.max(0, available - Number(line.writeOffMoney || 0)) : available
    },
    blank() {
      return { kind: 'receiptRed', code: '', bizDate: this.today(), customerId: '', partnerName: '', sourceId: '', amount: 0, remark: '', lines: [] }
    },
    loadSources() {
      request.get('/finance/doc/approvedBlueSources', {
        params: {
          kind: 'receiptRed',
          partnerId: this.form.customerId || '',
          includeSourceId: this.form.sourceId || '',
          excludeId: this.form.id || ''
        }
      }).then(res => { this.sources = res.data || [] }).catch(() => { this.sources = [] })
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'receiptRed' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.form.code = data.previewCode
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate('code'))
      }).catch(() => {})
    },
    init(id, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.codeReadonly = false
      this.picker = false
      if (!id) {
        this.form = this.blank()
        this.resolveCode()
        this.loadSources()
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
        return
      }
      request.get('/finance/doc/info', { params: { kind: 'receiptRed', id } }).then(res => {
        const row = res.data || {}
        this.form = Object.assign({ kind: 'receiptRed', lines: [] }, row)
        if (!Array.isArray(this.form.lines)) this.form.lines = []
        this.loadSources()
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    onClosed() {
      this.form = this.blank()
      this.readonly = false
    },
    editFromView() {
      if (!this.assertCanEditDoc('edit')) return
      this.readonly = false
    },
    deleteFromView() {
      if (!this.assertCanEditDoc('delete')) return
      this.$confirm('确定删除该收款红冲单?', '提示', { type: 'warning' }).then(() => {
        request.post('/finance/doc/delete', { kind: 'receiptRed', id: this.form.id }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    loadBlueLines() {
      if (this.readonly || !this.form.sourceId) {
        if (!this.form.sourceId) this.form.lines = []
        return
      }
      request.get('/finance/cash/pendingRedLines', { params: { receiptId: this.form.sourceId, excludeId: this.form.id || '' } }).then(res => {
        this.form.lines = (res.data || []).map(line => Object.assign({}, line, { writeOffMoney: Number(line.remainWriteOff || 0) }))
      }).catch(() => { this.form.lines = [] })
    },
    onPick(row) {
      this.form.customerId = row.customerId
      this.form.partnerName = row.customerName
      this.form.sourceId = ''
      this.form.lines = []
      this.loadSources()
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.form.lines || !this.form.lines.length) {
          this.$message.warning('请至少保留一条红冲明细')
          return
        }
        this.form.amount = this.writeOffTotal
        request.post('/finance/doc/save', this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    approve(row, pass) {
      const url = pass ? '/finance/doc/approve' : '/finance/doc/unapprove'
      this.$confirm(pass ? '确定审核?' : '确定弃审?', '提示', { type: 'warning' }).then(() => {
        request.post(url, { kind: 'receiptRed', id: row.id }).then(() => {
          this.$message.success(pass ? '审核成功' : '弃审成功')
          if (row && this.form && ((row.id && this.form.id === row.id) || (row.voucherId && this.form.voucherId === row.voucherId))) {
            this.$set(this.form, 'approveStatus', pass ? '2' : '0')
            this.readonly = true
          }
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
.red-lines-mobile { display: none; }
@media (max-width: 600px) {
  .red-lines-table { display: none; }
  .red-lines-mobile { display: block; max-height: 320px; overflow-y: auto; }
  .red-line-card { border: 1px solid #dcdfe6; border-radius: 6px; padding: 12px; margin-bottom: 8px; }
  .red-line-head, .red-line-amount { display: flex; align-items: center; gap: 8px; }
  .red-line-head strong { min-width: 0; flex: 1; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
  .red-line-amount { justify-content: space-between; margin-top: 10px; }
  .red-line-amount .el-input-number { flex: none; width: 132px; }
}
</style>
